<template>

    <rkm-row>

        <rkm-col cols="12">
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="data.form.unidades"
                            :validations="validations.unidade"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            :disabled="model.unidadeDisabled ? true : false"
                            value-field="id"
                            @change="resetInfraestrutura"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="infraestruturas"
                            :validations="validations.infraestrutura"
                            textField="nome"
                            v-model="model.infraestruturaId"
                            :disabled="model.unidadeDisabled ? true : false"
                            valueField="id"
                            show-default-option
                        />
                    </rkm-col>

                    <rkm-col cols="12">
                        <rkm-form-checkbox
                            inline
                            v-model="model.unidadeColeta"
                            :disabled="!model.infraestruturaId ? true : false"
                        >
                            Coleta
                        </rkm-form-checkbox>

                        <rkm-form-checkbox
                            inline
                            v-model="model.laboratorio"
                            :disabled="!model.infraestruturaId ? true : false"
                        >
                            Laboratório
                        </rkm-form-checkbox>
                    </rkm-col>

                    <rkm-col
                        cols="12"
                        v-if="model.unidadeColeta"
                    >
                        <rkm-area
                            title="Coleta"
                            type="fieldset"
                        >
                            <FormColeta
                                ref="FormColeta"
                                :data="data"
                                :unidadeColeta="unidadeColeta"
                                :unidadeId="model.unidadeId"
                                :infraestruturaId="model.infraestruturaId"
                                :unidadeDisabled="model.unidadeDisabled"
                            />
                        </rkm-area>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-col>

        <rkm-col
            v-if="model.infraestruturaId"
            cols="12"
        >
            <rkm-area
                title="Laboratório padrão"
                type="fieldset"
            >
                <FormLaboratorio
                    ref="FormLaboratorio"
                    :data="data"
                    :laboratorioPadraoInfraestruturaId="laboratorioPadraoInfraestruturaId"
                    :isLaboratorio="model.laboratorio"
                    :unidadeId="model.unidadeId"
                    :infraestruturaId="model.infraestruturaId"
                    @handleLaboratorio="handleLaboratorio"
                    @handleLaboratorioPadrao="handleLaboratorioPadrao"
                />
            </rkm-area>
        </rkm-col>
    </rkm-row>
</template>

<script>
// Mixins.
import { object } from '@/mixins'

// Components.
import FormColeta from './unidade-coleta/Form'
import FormLaboratorio from './laboratorio/Form'

export default {
    components: { FormColeta, FormLaboratorio },
    computed: {
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
            }
        },
        hasIndex() {

            return this.index !== null
        },
        infraestruturas() {

            if (this.model.unidadeId) {

                let infraestruturaPrincipal = this.data.form.unidades.find(u => u.id === this.model.unidadeId).infraestruturas

                if (!this.model.unidadeDisabled) {

                    this.getPrincipal(infraestruturaPrincipal)
                }

                return infraestruturaPrincipal
            }

            return []
        },
    },
    created() {

        this.load()
    },
    data: () => ({
        form: {
            unidades: {},
        },
        model: {
            id: null,
            unidadeId: null,
            infraestruturaId: null,
            unidadeDisabled: false,
            unidadeColeta: false,
            laboratorio: false,
            infraestrutura: []
        },
        unidadeColeta: [],
        laboratorioPadraoInfraestruturaId: null,
        laboratorioPadrao: {}
    }),
    methods: {
        load() {

            if (this.hasIndex) {

                const objId = this.data.model.unidades.findIndex((obj => obj.id == this.item.id));

                const data = this.data.model.unidades[objId]

                this.model.id = data.id
                this.model.unidadeId = data.unidadeId
                this.model.infraestruturaId = data.infraestruturaId
                this.model.unidadeDisabled = true
                this.model.unidadeColeta = data.unidadeColeta
                this.model.laboratorio = data.laboratorio
                this.unidadeColeta = data.unidadeColetaSolicitante
                this.laboratorioPadraoInfraestruturaId = data.laboratorioPadraoInfraestruturaId

                if (data.infraestrutura) {
                    this.model.infraestrutura = data.infraestrutura
                }

            }
        },
        getPrincipal(infraestruturaPrincipal) {

            if (infraestruturaPrincipal.find(u => u.principal === true)) {
                this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
            } else {
                this.model.infraestruturaId = null
            }
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                        if (this.hasUnidadeParametrizada()) {

                            this.showValidationNotification(
                                "Unidade já parametrizada com o local de atendimento"
                            )

                            return
                        }

                        if (this.model.unidadeColeta === false && this.model.laboratorio === false) {

                            this.showValidationNotification(
                                'É obrigatório informar se a unidade é coleta e/ou laboratório.'
                            )
                        }
                        else if (this.model.unidadeColeta === true && this.unidadeColeta.length === 0) {

                            this.showValidationNotification(
                                'É obrigatório informar pelo menos uma unidade solicitante para a coleta.'
                            )
                        }

                        else {

                            const unidade = this.data.form.unidades.find(u => u.id === this.model.unidadeId)
                            const infraestrutura = this.infraestruturas.find(u => u.id === this.model.infraestruturaId)

                             if (this.index == null) {

                                this.model.id = this.uniqueId('unidade' + new Date().getTime())
                            }

                            const param = {
                                id: this.model.id,
                                unidadeId: unidade.id,
                                nomeFantasia: unidade.nomeFantasia,
                                infraestrutura: this.model.infraestrutura,
                                infraestruturaId: infraestrutura.id,
                                infraestruturaNome: infraestrutura.nome,
                                infraestruturaPrincipal: infraestrutura.principal,
                                unidadeColeta: this.model.unidadeColeta,
                                unidadeColetaSolicitante: this.getUnidadeColetaSolicitante(),
                                laboratorio: this.model.laboratorio,
                                laboratorioPadraoInfraestruturaId: this.laboratorioPadraoInfraestruturaId,
                            }

                            if (this.hasIndex) {

                                const objIndex = this.data.model.unidades.findIndex((obj => obj.id == this.model.id));

                                this.$set(this.data.model.unidades, objIndex, this.clone(param))
                            }
                            else {

                                this.data.model.unidades.push(this.clone(param))
                            }

                            this.$emit('save', this.clone(param))
                        }
                })
        },
        hasUnidadeParametrizada() {

            return this.data.model.unidades.find((unidade) => unidade.id !== this.model.id
                && unidade.unidadeId === this.model.unidadeId && unidade.infraestruturaId === this.model.infraestruturaId)
        },
        getUnidadeColetaSolicitante() {

            if (this.model.unidadeColeta === true) {
                return this.unidadeColeta
            } else {
                return []
            }
        },
        handleLaboratorio() {

            this.model.laboratorio = true
        },
        handleLaboratorioPadrao(value) {

            this.laboratorioPadraoInfraestruturaId = value
        },
        resetInfraestrutura() {

            this.model.infraestruturaId = null
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
        index: { type: Number, default: null },
        item: { type: Object, default: null },
    },
}
</script>